import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ReportsService } from 'src/app/services/reports.service';
import saveAs from 'file-saver';
import { Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';


@Component({
  selector: 'app-cao-financial-details',
  templateUrl: './cao-financial-details.component.html',
  styleUrls: ['./cao-financial-details.component.scss']
})
export class CaoFinancialDetailsComponent implements OnInit {
  @ViewChild('lotDataTable') tableContainer: ElementRef;
  @ViewChild('lotDetailsTable') tableContainer2: ElementRef;
  miUnderProcessReport: MenuItem[];
  lotDetailReport: MenuItem[];
  
  public totalSubsidyDisbursed: any = 0;
  public totalSubsidyDisbursedPDMC: any = 0;
  public totalSubsidyDisbursedTank: any = 0;

  public tankSubsidyChartData: any;
  public PDMCSubsidyChartData: any;
  public subsidyChartData: any;

  public subsidyDisbData: any;
  public subscriptions: any = [];
  public subjectSub: any;

  public subsidyDisSumYearwise: any;
  public tankSubsidyDisSumYearwise: any;
  public PDMCSubsidyDisSumYearwise: any;

  public options: any;
  public lotNoByFinYear: any = [];
  public loading: boolean = false;
  public selectedLotNo: any;
  public lotDetails: any = [];

  public tableHeader: any = '';

  public lotData: any = [];
  public loading1: boolean = false;
  public showLotDataDialog: boolean = false;

  constructor(
    private reportsService: ReportsService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private router: Router,
    private cryptoJsService: CryptoJsService, 
  ) { }

  ngOnInit(): void {
    this.loadData();

    this.miUnderProcessReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.lotNoByFinYear, `Lot No List`);
        },
      }
    ];
    this.lotDetailReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelForLot(this.lotDetails, `Lot Detail`);
        },
      }
    ];
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  exportExcelForLot(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Lot No': d.Lot_No,
          'App ID': d.AppID,
          'PFMS Payment Date': d.PFMSPaymentDate,
          'Centre Share Amount': d.Centre_share_amt,
          'State Share Amount': d.State_share_amt,
          'TopUp': d.TopUp,
          'aby': d.aby,
          'Status': d.Status,
          'Remarks': d.Remarks,
          'CAORemarks': d.CAORemarks,
          'Fin_Year': d.Fin_Year,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Lot No': d.Lot_No,
          'Total Application': d.total_apps,
          'Total Centre Share': d.total_centre_share,
          'Total State Share': d.total_state_share,
          'Total Topup': d.total_topup,
          'Total ABY': d.total_aby,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }


  loadData() {
    this.loader.start();
    let sub = this.reportsService
      .getSubsidyDistribution(1)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.subsidyDisbData = data;
            this.computeValue(data);
          } else {
            this.subsidyDisbData = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.subsidyDisbData = [];
        },
      });

    this.subscriptions.push(sub);
  }

  computeValue(data) {
    const CRORE_CONVERSION = 10000000; // 1 crore = 10 million rupees

    // 1. Total Subsidy Dis Sum
    this.totalSubsidyDisbursed = data.reduce((acc, item) => acc + item.subsidy_dis, 0) / CRORE_CONVERSION;

    // 2. Sum of Tank and Non-Tank
    this.totalSubsidyDisbursedPDMC = data
      .filter(item => item.sub_type !== 'Tank')
      .reduce((acc, item) => acc + item.subsidy_dis, 0) / CRORE_CONVERSION;

    this.totalSubsidyDisbursedTank = data
      .filter(item => item.sub_type === 'Tank')
      .reduce((acc, item) => acc + item.subsidy_dis, 0) / CRORE_CONVERSION;


    this.animateCounter('totalSubsidyDisbursed', this.totalSubsidyDisbursed);
    this.animateCounter('totalSubsidyDisbursedPDMC', this.totalSubsidyDisbursedPDMC);
    this.animateCounter('totalSubsidyDisbursedTank', this.totalSubsidyDisbursedTank);


    // Helper function to round to 2 decimal places
    const toCrores = (amount: number) => (amount / CRORE_CONVERSION).toFixed(3);

    const subsidyDisSumYearwise = data
      .reduce((acc, item) => {
        if (!acc[item.Fin_Year]) {
          acc[item.Fin_Year] = 0;
        }
        acc[item.Fin_Year] += item.subsidy_dis;
        return acc;
      }, {});

    // Formatting keys with year and sum in crores
    this.subsidyDisSumYearwise = Object.keys(subsidyDisSumYearwise).reduce((acc, year) => {
      const sumInCrores = toCrores(subsidyDisSumYearwise[year]);
      acc[`${year} (${sumInCrores})`] = parseFloat(sumInCrores);
      return acc;
    }, {});

    // 3. Yearwise sum for Tank
    const tankSubsidyDisSumYearwise = data
      .filter(item => item.sub_type === 'Tank')
      .reduce((acc, item) => {
        if (!acc[item.Fin_Year]) {
          acc[item.Fin_Year] = 0;
        }
        acc[item.Fin_Year] += item.subsidy_dis;
        return acc;
      }, {});

    // Formatting keys with year and sum in crores
    this.tankSubsidyDisSumYearwise = Object.keys(tankSubsidyDisSumYearwise).reduce((acc, year) => {
      const sumInCrores = toCrores(tankSubsidyDisSumYearwise[year]);
      acc[`${year} (${sumInCrores})`] = parseFloat(sumInCrores);
      return acc;
    }, {});

    // 4. Yearwise sum for Non-Tank
    const nonTankSubsidyDisSumYearwise = data
      .filter(item => item.sub_type !== 'Tank')
      .reduce((acc, item) => {
        if (!acc[item.Fin_Year]) {
          acc[item.Fin_Year] = 0;
        }
        acc[item.Fin_Year] += item.subsidy_dis;
        return acc;
      }, {});

    // Formatting keys with year and sum in crores
    this.PDMCSubsidyDisSumYearwise = Object.keys(nonTankSubsidyDisSumYearwise).reduce((acc, year) => {
      const sumInCrores = toCrores(nonTankSubsidyDisSumYearwise[year]);
      acc[`${year} (${sumInCrores})`] = parseFloat(sumInCrores);
      return acc;
    }, {});

    this.loadGraph();
  }

  private animateCounter(property: string, endValue: number): void {
    const duration = 2000; // Duration of the animation in milliseconds
    const frameRate = 60; // Number of updates per second
    const totalFrames = (duration / 1000) * frameRate;
    let frame = 0;

    const intervalId = setInterval(() => {
      frame++;
      const progress = frame / totalFrames;
      const currentCount = Math.floor(progress * endValue);

      this[property] = currentCount;

      if (frame >= totalFrames) {
        clearInterval(intervalId);
        this[property] = endValue; // Ensure the final value is set
      }
    }, 1000 / frameRate);
  }

  loadGraph() {
    // Extract and sort the keys based on the financial year
    const tankSortedKeys = Object.keys(this.tankSubsidyDisSumYearwise).sort((a, b) => {
      const yearA = parseInt(a.split(' ')[0].split('-')[0], 10);
      const yearB = parseInt(b.split(' ')[0].split('-')[0], 10);

      return yearA - yearB;
    });

    const tankSortedValues = tankSortedKeys.map(key => this.tankSubsidyDisSumYearwise[key]);

    this.tankSubsidyChartData = {
      labels: tankSortedKeys,
      datasets: [
        {
          data: tankSortedValues,
          backgroundColor: [
            '#0073e6',
            '#3399ff',
            '#80bfff'
          ],
          hoverBackgroundColor: [
            '#0073e6',
            '#3399ff',
            '#80bfff'
          ],
          borderWidth: 2
        },
      ],
    };

    // Extract and sort the keys based on the financial year
    const PDMCSortedKeys = Object.keys(this.PDMCSubsidyDisSumYearwise).sort((a, b) => {
      const yearA = parseInt(a.split(' ')[0].split('-')[0], 10);
      const yearB = parseInt(b.split(' ')[0].split('-')[0], 10);

      return yearA - yearB;
    });

    const PDMCSortedValues = PDMCSortedKeys.map(key => this.PDMCSubsidyDisSumYearwise[key]);


    this.PDMCSubsidyChartData = {
      labels: PDMCSortedKeys,
      datasets: [
        {
          data: PDMCSortedValues,
          backgroundColor: [
            '#26734d',
            '#39ac73',
            '#79d2a6'
          ],
          hoverBackgroundColor: [
            '#26734d',
            '#39ac73',
            '#79d2a6'
          ],
          borderWidth: 2
        },
      ],
    };

    // Extract and sort the keys based on the financial year
    const sortedKeys = Object.keys(this.subsidyDisSumYearwise).sort((a, b) => {
      const yearA = parseInt(a.split(' ')[0].split('-')[0], 10);
      const yearB = parseInt(b.split(' ')[0].split('-')[0], 10);

      return yearA - yearB;
    });

    const sortedValues = sortedKeys.map(key => this.subsidyDisSumYearwise[key]);

    this.subsidyChartData = {
      labels: sortedKeys,
      datasets: [
        {
          data: sortedValues,
          backgroundColor: [
            '#b30000',
            '#ff3333',
            '#ff9999'
          ],
          hoverBackgroundColor: [
            '#b30000',
            '#ff3333',
            '#ff9999'
          ],
          borderWidth: 2
        },
      ],
    };

    this.options = {
      responsive: true,
      plugins: {
        datalabels: {
          anchor: 'center',
          align: 'end',
          color: 'white',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          labels: {
            usePointStyle: true,
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
        },
      },
      animation: {
        animateScale: true,
        animateRotate: true
      },
      cutout: '0%',
      elements: {
        arc: {
          borderWidth: 0,
          borderAlign: 'center',
          offset: 15
        }
      },
    };
  }

  onClickPie(event, lotType) {
    const index = event.element.index; 
    // const clickedData = this.subsidyChartData.datasets[0].data[index]; 

    const clickedLabel = this.subsidyChartData.labels[index];

    const financialYear = clickedLabel.split(' ')[0];
    setTimeout( () => this.tableContainer.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400);

    let lotName = lotType;
    if(lotName == ''){
      lotName = 'PDMC + Tank'
    }
    this.tableHeader =  `All lots of (${lotName}) of Financial Year: ${financialYear}`

    this.getLotNoByFinYear(financialYear, lotType);
  }

  getLotNoByFinYear(finYear, lotType) {
    this.loader.start();
    let sub = this.reportsService
      .getDistinctLotNoByFinYear(finYear, lotType)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.lotNoByFinYear = data;
          } else {
            this.lotNoByFinYear = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.lotNoByFinYear = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSelectRow(val){
    this.selectedLotNo = val?.Lot_No;
    this.loadLotDetails(val?.Lot_No);
    setTimeout( () => this.tableContainer2.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400)
  }

  onClickLotNo(val){
    let lotNo = val?.Lot_No;
    let lotType = lotNo.slice(4, 7);
    if(lotType == "STF"){
      this.showLotDataDialog = true;
      this.lotData = [];
      let apiName = 'GetApplicationsForMISubsidyToFarmerPFMSExport';
      this.loadLotData(apiName, lotNo);
    }else if(lotType == "STV"){
      this.showLotDataDialog = true;
      this.lotData = [];
      let apiName = 'GetApplicationsForMISubsidyToVendorPFMSExport';
      this.loadLotData(apiName, lotNo);
    }else if(lotType == "TS1"){
      this.showLotDataDialog = true;
      this.lotData = [];
      this.loadTankLotData(1, lotNo);
    }else if(lotType == "TS2"){
      this.showLotDataDialog = true;
      this.lotData = [];
      this.loadTankLotData(2, lotNo);
    }else if(lotType == "TS3"){
      this.showLotDataDialog = true;
      this.lotData = [];
      this.loadTankLotData(3, lotNo);
    }
  }

  hideDialog(){
    this.showLotDataDialog = false;
    this.lotData = [];
  }

  loadTankLotData(tankType, lotNo) {
    // this.loader.start();
    this.loading1 = true;
    let sub = this.reportsService
      .getTankLotDataInCAOFinDashboard(tankType, lotNo, '', '')
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading1 = false;
          if (data?.length > 0) {
            this.lotData = data;
          } else {
            this.lotData = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading1 = false;
          this.lotData = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  loadLotData(apiName, lotNo) {
    // this.loader.start();
    this.loading1 = true;
    let sub = this.reportsService
      .getLotDataInCAOFinDashboard(apiName, lotNo, '', '')
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading1 = false;
          if (data?.length > 0) {
            this.lotData = data;
          } else {
            this.lotData = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading1 = false;
          this.lotData = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  loadLotDetails(lotNo) {
    this.loader.start();
    let sub = this.reportsService
      .getPaymentsByLotNo(lotNo)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.lotDetails = data;
          } else {
            this.lotDetails = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.lotDetails = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onClickApp(appId) {
    const link = this.router.serializeUrl(
      this.router.createUrlTree([
        this.router.url.split('/')[1],
        'print',
      ],  { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } }));
    window.open(link, '_blank');
  }
}
